import type { components } from '@pba/types-openapi-client';
import { type ProgramSlim, createProgramSlim } from './slim';

export type ProgramListItem = ProgramSlim;

export const createProgramList = (data: components['schemas']['ProgramSlim']): ProgramListItem => ({
  ...createProgramSlim(data),
});
